import React, { useEffect, useState } from "react";
import { Drawer, Divider, Button, Image } from "antd";
import api from "../../../../api";
import { useToast } from "../../../../components/toast";
import styles from "../../styles.module.scss";
import UploadImage from "../../../../components/upload/UploadImage";

export default function AddImages({ open, onClose, trigger }) {
  const [gallery, setGallery] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const toast = useToast();

  useEffect(() => {
    if (!open) return;

    const loadImages = async () => {
      const res = await api.get_images();
      // console.log("image -->", res);
      if (res.status === 200) {
        setGallery(res.data.data || []);
      }
    };

    loadImages();
  }, [open]);

  const toggleSelect = (url) => {
    setSelectedImages((prev) => {
      if (prev.includes(url)) {
        return prev.filter((v) => v !== url);
      }
      return [...prev, url];
    });
  };

  const submitHandler = async () => {
    if (!selectedImages.length) {
      toast("Ядаж нэг зураг сонгоно уу", "warning");
      return;
    }

    // console.log("selectedImages -->", selectedImages);
    const res = await api.add_banners({ items: selectedImages });
    // console.log("add images --->", res);
    if (res.status === 201) {
      toast("Зураг сонголт хадгалагдлаа", "success");
      setSelectedImages([]);
      onClose?.(true);
      trigger?.();
    } else {
      toast(res.data.message || "Алдаа гарлаа", "error");
    }
  };

  return (
    <Drawer
      title="Баннер нэмэх"
      open={open}
      onClose={() => onClose?.(false)}
      width={720}
      styles={{ body: { paddingBottom: 16 } }}
      extra={
        <Button
          type="primary"
          onClick={submitHandler}
          disabled={!selectedImages.length}
        >
          Хадгалах
        </Button>
      }
    >
      <Divider
        orientation="left"
        style={{
          borderColor: "#ddd",
          fontSize: 14,
          fontWeight: 600,
          marginBottom: 15,
        }}
      >
        Сонгогдсон зурагнууд
      </Divider>
      <div className={styles.galleryGrid}>
        {selectedImages.map((item, i) => {
          return (
            <div key={i} className={`${styles.imgWrapper}`}>
              <Image
                src={item}
                alt={`gallery-${i}`}
                width="100%"
                height="100%"
                imgStyle={{ objectFit: "contain" }}
                preview={false}
              />
            </div>
          );
        })}
        <UploadImage
          title={"Зураг нэмэх"}
          onUpload={(url) => {
            toggleSelect(url);
          }}
        />
      </div>

      <Divider
        orientation="left"
        className="mt-5"
        style={{
          borderColor: "#ddd",
          fontSize: 14,
          fontWeight: 600,
          marginBottom: 15,
        }}
      >
        Зургийн жагсаалтаас сонгох
      </Divider>

      <div className={styles.galleryGrid}>
        {gallery.map((item, i) => {
          const url = item.url;
          const isSelected = selectedImages.includes(url);

          return (
            <div
              key={url || i}
              className={`${styles.imgWrapper} ${
                isSelected ? styles.imgWrapperSelected : ""
              }`}
              onClick={() => toggleSelect(url)}
            >
              <Image
                src={url}
                alt={`gallery-${i}`}
                width="100%"
                height="100%"
                imgStyle={{ objectFit: "contain" }}
                preview={false}
              />
            </div>
          );
        })}
      </div>
    </Drawer>
  );
}
